import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { services } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'apex-divisions',
  templateUrl: './apex-divisions.component.html'
})
export class ApexDivisionsComponent {
  service = 'divisions';
  availableServices = services['apex'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'apex',
    service: 'divisions',
    type: 'solo',
    title: {
      en: 'Rank Boosting',
    },
    subtitle: {
      en: 'Guarantee your desired Rank in Solo or Duo Services',
      fr: 'Garantissez le rang que vous souhaitez avec les services solo ou duo',
      de: 'Sichern Sie sich Ihren gewünschten Rang in den Solo oder Duo Services',
      pt: 'Garante o rank que desejas em serviços de Solo ou Duo Boosting',
      es: 'Garantiza el rango deseado en los servicios en Solo o Dúo',
    },
    start: 12,
    desired: 13
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Rank Boosting Service?",
        answer: "A rank boost is a type of boosting that guarantees you get the Rank you desire in the fastest and safest way."
      },
      {
        question: "What If I Demote Before The Service Is Complete?",
        answer: "You can rest assured that the service you purchased is guaranteed. In the rare occurrence of such an unfortunate event, we will overcome it and fulfill the service as originally intended."
      },
      {
        question: "Can I Play Together With The Booster?",
        answer: "Absolutely! You can achieve that by simply selecting the \"DUO\" red button located in the order additions menu."
      },
      {
        question: "Is My Account Safe During The Boosting Process?",
        answer: "Yes, your account safety is our top priority. We employ various measures to ensure that your account remains secure throughout the boosting process."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Sure thing! You are free to play any game modes except Ranked, as this interferes with your booster’s progress. If it’s any game mode you are welcome to pause your order and resume later."
      },
      {
        question: "What If I Have More Questions?",
        answer: "We have a FAQ and dedicated Live Support Team, online 24 hours per day, always ready to help you through every step and ready to answer all your questions!"
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de boost de rang?",
        answer: "Un boost de rang est un type de boosting qui vous garantit d\'obtenir le rang que vous désirez de la manière la plus rapide et la plus sûre",
      },
      {
        question: "Que se passe-t-il si je rétrograde avant la fin du service?",
        answer: "Vous pouvez être assuré que le service que vous avez acheté est garanti. Dans les rares cas où un tel événement malheureux se produirait, nous le surmonterions et exécuterions le service comme prévu initialement."
      },
      {
        question: "Puis-je jouer avec le Booster?",
        answer: "Absolument! Pour cela, il vous suffit de sélectionner le bouton rouge \"DUO\" situé dans le menu des ajouts à la commande."
      },
      {
        question: "Mon compte est-il en sécurité pendant le processus de boosting?",
        answer: "Oui, la sécurité de votre compte est notre priorité absolue. Nous employons plusieurs mesures pour nous assurer que votre compte reste sécurisé tout au long du processus de boosting."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Bien sûr ! Vous êtes libre de jouer à tous les modes de jeu, sauf au mode Classé, car cela interfère avec la progression de votre booster. S\'il s\'agit de n\'importe quel mode de jeu, vous pouvez interrompre votre commande et la reprendre plus tard."
      },
      {
        question: "Et si j\'ai d\'autres questions?",
        answer: "Nous disposons d\'une FAQ et d\'une équipe d\'assistance en ligne dédiée, en ligne 24 heures sur 24, toujours prête à vous aider à chaque étape et à répondre à toutes vos questions!"
      }
    ],
    de: [
      {
        question: "Was ist ein Rank Boosting Service?",
        answer: "Ein Rank Boost ist eine Form des Boostings, die dir garantiert, dass du den gewünschten Rang auf die schnellste und sicherste Weise erreichst."
      },
      {
        question: "Was ist, wenn ich zurückgestuft werde, bevor der Service abgeschlossen ist?",
        answer: "Du kannst sicher sein: Die Dienstleistung, die du gekauft hast, ist garantiert. In dem seltenen Fall, dass etwas Unvorhergesehenes passiert, werden wir das meistern und den Dienst wie geplant ausführen."
      },
      {
        question: "Kann ich mit dem Booster zusammen spielen?",
        answer: "Auf jeden Fall! Das kannst du erreichen, indem du auf die rote Schaltfläche \"DUO\" im Bestellungszusatzmenü klickst."
      },
      {
        question: "Ist mein Konto während des Boosting-Prozesses sicher?",
        answer: "Ja, die Sicherheit deines Kontos hat für uns oberste Priorität. Um die Sicherheit deines Kontos während des Boosting-Prozesses zu gewährleisten, ergreifen wir verschiedene Maßnahmen."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Aber sicher! Mit Ausnahme der Ranglistenspiele, die den Fortschritt deines Boosters beeinflussen, kannst du alle Spielmodi spielen. Du kannst deine Bestellung in jedem Spielmodus unterbrechen und zu einem späteren Zeitpunkt fortsetzen."
      },
      {
        question: "Was ist, wenn ich noch mehr Fragen habe?",
        answer: "Unser engagiertes Live-Support-Team ist rund um die Uhr online, um dir bei jedem Schritt zu helfen und all deine Fragen zu beantworten!"
      }
    ],
    pt: [
      {
        "question": "O Que É Um Serviço De Rank Boosting em Apex Legends?",
        "answer": "Um Rank Boosting é um tipo de serviço que garante que obténs o rank que desejas de forma rápida e segura."
      },
      {
        "question": "O Que Acontece Se Eu Perder RP Durante O Serviço?",
        "answer": "O serviço é 100% garantido. Se tal acontecer, iremos rapidamente recuperar e garantir que atinges o rank desejado."
      },
      {
        "question": "Posso Jogar Com O Booster Em Duo?",
        "answer": "Sim, podes. Para isso, vai até ao menu de personalização do pedido e seleciona \"Duo\" antes de clicar em \"Comprar Boost Agora\"."
      },
      {
        "question": "A Minha Conta Está Segura Durante O Boost?",
        "answer": "Sim, a segurança da tua conta é a nossa principal prioridade. Implementamos medidas para garantir que a tua conta permanece segura durante todo o processo."
      },
      {
        "question": "Posso Jogar Enquanto O Serviço Está Activo?",
        "answer": "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. excepto isso, basta falares e agendares com o teu booster."
      },
      {
        "question": "E se eu tiver mais perguntas?",
        "answer": "Nesse caso temos um chat disponível 24 horas por dia, com uma equipa sempre pronta para ajudar-te em cada etapa e responder a todas as tuas perguntas!"
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de boosting de rango?",
        answer: "Un Boost de Rango es un tipo de boosting que te garantiza obtener el Rango que deseas de la manera más rápida y segura."
      },
      {
        question: "¿Qué pasa si desciendo antes de que termine el servicio?",
        answer: "Puedes estar seguro de que el servicio que has adquirido está garantizado. En el raro caso de que se produzca un infortunio de este tipo, lo superaremos y cumpliremos el servicio tal y como estaba previsto en un principio."
      },
      {
        question: "¿Puedo jugar con los boosters?",
        answer: "Por supuesto. Puedes conseguirlo simplemente seleccionando el botón rojo \"DUO\" situado en el menú de añadir pedidos."
      },
      {
        question: "¿Es segura mi cuenta durante el proceso de Boost?",
        answer: "Sí, la seguridad de su cuenta es nuestra máxima prioridad. Empleamos varias medidas para garantizar la seguridad de tu cuenta durante todo el proceso de Boost."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Por supuesto. Eres libre de jugar en cualquier modo de juego excepto en Clasificatorio, ya que esto interfiere con el progreso de tus boosters. Si se trata de cualquier modo de juego, puedes pausar tu pedido y reanudarlo más tarde."
      },
      {
        question: "¿Y si tengo más preguntas?",
        answer: "Contamos con un equipo de asistencia en directo dedicado a las preguntas más frecuentes, en línea las 24 horas del día, siempre dispuesto a ayudarte en cada paso y a responder a todas tus preguntas."
      }
    ]
  }

  private page = {
    title: {
      en: "Apex Legends - Rank Boosting for Apex Legends",
      fr: "Apex Legends - Boost de classement pour Apex Legends",
      de: "Apex Legends - Rangverbesserung für Apex Legends",
      pt: "Apex Legends - Rank Boost para Apex Legends",
      es: "Apex Legends - Boosting de rango para Apex Legends",
    },
    metaDescription: {
      en: "Rise in Apex Legends ranks with GGBoost. Opt for the Best and Safest boosting services, ensuring Standout Performance Every Match",
      fr: "Montez dans les rangs d'Apex Legends avec GGBoost. Optez pour les meilleurs services de boosting, assurant des performances exceptionnelles à chaque match",
      de: "Steige mit GGBoost in die Apex Legends auf. Entscheide dich für den besten und sichersten Boosting-Dienst, der dir in jedem Spiel hervorragende Leistungen gewährleistet.",
      pt: "Suba nos rankings do Apex Legends com GGBoost. Opte pelos melhores e mais seguros serviços de aumento de rank, garantindo um desempenho excepcional em cada partida",
      es: "Sube de nivel en Apex Legends con GGBoost. Opta por los mejores y más seguros servicios de boosting, garantizando un rendimiento sobresaliente en cada partido.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
    });

    title.setTitle(this.page.title[this.lang] || this.page.title['en']);
    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      }
    );
  }
}
